// @flow

// Actions
import { clickTrackingEvent } from 'store/reducers/clickTracking/actions';

// Action Type
import * as actionTypesNavigation from 'store/reducers/navigation/actionTypes';

// Constants
import * as routes from 'constants/routes';

// types
import type { Store, Action } from 'types/redux';

export const clickTrackingMiddleware = (store: Store) => (
  next: (action: Action) => any
) => (action: any) => {
  switch (action.type) {
    // @CLICKTRACKING PAGE TRACKING EVENTS
    case actionTypesNavigation.SET_CURRENT_PATH: {
      if (action.payload === routes.VEHICLE_ROUTE) {
        store.dispatch(clickTrackingEvent('VEHICLE'));
      }
      if (action.payload === routes.SERVICES_ROUTE) {
        store.dispatch(clickTrackingEvent('SERVICES'));
      }
      if (action.payload === routes.APPOINTMENT_ROUTE) {
        store.dispatch(clickTrackingEvent('TIME'));
      }
      if (action.payload === routes.REVIEW_ROUTE) {
        store.dispatch(clickTrackingEvent('REVIEW'));
      }
      break;
    }
    default:
  }
  next(action);
};



// WEBPACK FOOTER //
// ./src/store/middlewares/clickTracking-middleware.js